import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getDisclosureLevel1,
  saveBatchDisclosureLevel1,
} from '../../api/disclosureLevel1';
import type { DisclosureLevel1 } from '../../types/DisclosureLevel1';
import { t } from '../../i18n/t';

const columnDefs: ColDef<DisclosureLevel1>[] = [
  {
    field: 'codeId',
    headerName: t('disclosureLevel1.columns.codeId'),
    width: 140,
    cellDataType: 'text',
    // String natural PK: editable on Add only, read-only after save. The
    // leading zero ('01'..'10') must display and round-trip as a string.
    editable: (params: EditableCallbackParams<DisclosureLevel1>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'codeName',
    headerName: t('disclosureLevel1.columns.codeName'),
    flex: 1,
    editable: true,
  },
];

const newRowDefaults = (): Partial<DisclosureLevel1> => ({
  codeId: '',
  codeName: '',
});

export function DisclosureLevel1Page() {
  return (
    <LopCrudPage<DisclosureLevel1>
      resourceCode="disclosureLevel1"
      titleKey="disclosureLevel1.pageTitle"
      idField="codeId"
      getRows={getDisclosureLevel1}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchDisclosureLevel1(added, modified, deletedIds as string[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
